exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tempo-borda[data-v-7d294bf2]{border:1px solid #ddd;margin:0;margin-bottom:1em;padding-top:.5em;border-radius:.2em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7d294bf2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/followair/manutencao/cadastro/inspecao/components/tempos.vue
// module id = 515
// module chunks = 0